import { api } from '@/lib/api/client';
import type {
  FirmKpiSummaryParams,
  KpiSummary,
  KpiSummaryParams,
  MonthlyKPI,
} from '../types';

export const kpiApi = {
  getSummary: async (params: KpiSummaryParams): Promise<KpiSummary> => {
    return api.get<KpiSummary>('/kpi/summary', { params });
  },

  // Firm-wide aggregate — only callers with `kpi:get:all` may call this.
  getFirmSummary: async (params: FirmKpiSummaryParams): Promise<KpiSummary> => {
    return api.get<KpiSummary>('/kpi/firm-summary', { params });
  },

  getMonthlyKPI: async (userId?: number): Promise<MonthlyKPI[]> => {
    const params: Record<string, unknown> = {};
    if (userId) params.userId = userId;
    return api.get<MonthlyKPI[]>('/monthly-kpi', { params });
  },
};

export const kpiQueryKeys = {
  all: ['kpi'] as const,
  summary: (params: KpiSummaryParams) =>
    [...kpiQueryKeys.all, 'summary', params] as const,
  firmSummary: (params: FirmKpiSummaryParams) =>
    [...kpiQueryKeys.all, 'firmSummary', params] as const,
  monthlyKpi: (userId: number) =>
    [...kpiQueryKeys.all, 'monthlyKpi', userId] as const,
};
